<script>
  export default {
    name: 'Input',
    props: ['headers', 'form', 'field', 'items', 'itemsPerPage', 'name', 'rules', 'label'],
    data(){
      return {
        menu: false
      }
    },
    computed: {
      model: {
        get() {
          if (!this.$store.state[this.form][this.field]) return null
          const [ month, day , year ] = this.$store.state[this.form][this.field].split('/')
          return `${year}-${month}-${day}`
        },
        set(v) {
          if (!v) return null
          const [year, month, day] = v.split('-')
          v = `${month}/${day}/${year}`
          this.$store.dispatch(`${ this.form }/SET_FIELD`, { key: this.field, value: v })
        },
      },
      dateFormatted() {
        return this.$store.state[this.form][this.field]
      },
    },
    methods: {
      clearDate() {
        this.$store.dispatch(`${ this.form }/SET_FIELD`, { key: this.field, value: '' })
      }     
    },
  }
</script>

<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        prepend-icon="mdi-calendar"
        readonly
        clearable
        @click:clear="clearDate"
        v-bind="attrs"
        v-on="on"
        :rules="rules"
        :label="label"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="model"
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>
